<template>
  <b-dropdown right :text="summaryText" variant="outline-dark" @hide="saveChanges" ref="dropdown" :disabled="disabled">
    <b-dropdown-form style="min-width:320px" v-on:submit.prevent.stop="saveAndClose">
      <b-form-group v-if="companies" label="Company:">
        <b-form-select v-model="selectedCompany" required>
          <option value="null" disabled>Please select an option</option>
          <option v-for="(company, companyIndex) in companies" :key="companyIndex" :value="company">{{company.name}}</option>
        </b-form-select>
      </b-form-group>
      <b-form-group label="Team(s):" v-if="availableTeams.length > 0">
        <b-form-checkbox-group stacked v-model="selectedTeams" name="teams">
          <b-form-checkbox v-for="(team, teamIndex) in availableTeams" :key="teamIndex" :value="team">{{team.name}}</b-form-checkbox>
        </b-form-checkbox-group>
      </b-form-group>
      <b-alert :show="!isValid" variant="danger">{{errorMessage}}</b-alert>
      <p class="text-right mb-0">
        <b-button size="sm" variant="secondary" @click="resetAndClose">Cancel</b-button>
        <b-button size="sm" variant="primary" @click="saveAndClose">Update</b-button>
      </p>
    </b-dropdown-form>
  </b-dropdown>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'TeamFilter',
  props: ['filter', 'companies', 'allTeams', 'disabled'],
  data () {
    var company = (this.companies != null && this.filter.company_id != null) ? this.companies.find((c) => { return parseInt(this.filter.company_id) === c.id }) : null
    var availableTeams = []
    if (this.companies != null) {
      if (company != null) {
        availableTeams = company.teams
      }
    } else {
      availableTeams = this.allTeams
    }
    return {
      selectedCompany: company,
      selectedTeams: availableTeams.filter((t) => { return this.filter.team_ids.indexOf(t.id) !== -1 }),
      isValid: true,
      errorMessage: ''
    }
  },
  components: {},
  computed: {
    availableTeams () {
      if (this.companies != null) {
        if (this.selectedCompany != null) {
          return this.selectedCompany.teams
        } else {
          return []
        }
      } else {
        return this.allTeams
      }
    },
    summaryText () {
      if (this.filter.team_ids == null || this.filter.team_ids.length === 0) {
        return 'None'
      } else if (this.filter.team_ids.length === 1) {
        return this.filterTeams[0].name
      } else {
        return `${this.filter.team_ids.length} teams`
      }
    },
    filterCompany () {
      if (this.filter.company_id != null) {
        return this.companies.find((c) => { return parseInt(this.filter.company_id) === c.id })
      } else {
        return null
      }
    },
    filterTeams () {
      var availableTeams = []
      if (this.filterCompany != null) {
        availableTeams = this.filterCompany.teams
      } else {
        availableTeams = this.allTeams
      }
      return availableTeams.filter((t) => { return this.filter.team_ids.find((id) => { return parseInt(id) === t.id }) != null })
    }
  },
  watch: {
    selectedCompany () {
      this.selectedTeams = []
    }
  },
  mounted () {
  },
  methods: {
    validate () {
      this.isValid = true
      if (this.companies != null) {
        if (this.selectedCompany == null) {
          this.isValid = false
          this.errorMessage = 'Please select a company'
          return this.isValid
        }
      }
      if (this.selectedTeams.length === 0) {
        this.isValid = false
        this.errorMessage = 'Please select at least one team'
      }
      return this.isValid
    },
    resetAndClose (evt) {
      this.selectedCompany = _.clone(this.filterCompany)
      this.selectedTeams = _.clone(this.filterTeams)
      this.isValid = true
      this.errorMessage = ''
      this.$refs.dropdown.hide()
    },
    saveChanges (evt) {
      if (this.validate()) {
        this.commit()
      } else {
        evt.preventDefault()
      }
    },
    saveAndClose () {
      if (this.validate()) {
        this.$refs.dropdown.hide()
      }
    },
    commit () {
      if (this.selectedCompany != null) {
        this.filter.company_id = this.selectedCompany.id
      } else {
        this.filter.company_id = null
      }
      this.filter.team_ids = this.selectedTeams.map((t) => { return t.id })
      this.$emit('input', this.filter)
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/reports/TeamFilter.vue